import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { PlatformTemplate } from 'templates';
import { Admin, AdminCategories } from 'pages';

export default function Routes() {
  return (
    <PlatformTemplate>
      <Switch>
        <Route exact path="/admin">
          <Admin />
        </Route>
        <Route exact path="/admin/categories">
          <AdminCategories />
        </Route>
      </Switch>
    </PlatformTemplate>
  );
}
